import React, { useState } from 'react';
import api from '../services/api';
import './ModalGerarEstrutura.css';

const ModalGerarEstrutura = ({ isOpen, onClose, onSuccess }) => {
  const [ano, setAno] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await api.post('/admin/gerar-estrutura', { ano: parseInt(ano) });
      
      if (response.data.success) {
        setSuccess(`Estrutura criada com sucesso para o ano ${ano}!`);
        setTimeout(() => {
          onClose();
          if (onSuccess) onSuccess();
        }, 2000);
      } else {
        setError(response.data.message || 'Erro ao gerar estrutura');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao gerar estrutura');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setAno(new Date().getFullYear());
      setError('');
      setSuccess('');
      onClose();
    }
  };

  return (
    <div className="modal-overlay-estrutura" onClick={handleClose}>
      <div className="modal-content-estrutura" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-estrutura">
          <h2>Gerar Estrutura de Diretórios</h2>
          <button className="modal-close-estrutura" onClick={handleClose} disabled={loading}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body-estrutura">
          <div className="form-group-estrutura">
            <label htmlFor="ano-estrutura">Ano de Trabalho:</label>
            <input
              id="ano-estrutura"
              type="number"
              min="2000"
              max="2100"
              value={ano}
              onChange={(e) => setAno(e.target.value)}
              required
              disabled={loading}
              className="input-ano-estrutura"
              placeholder="Ex: 2025"
            />
            <p className="form-help-estrutura">
              Será criada a estrutura completa de diretórios para todas as secretarias e subsecretarias cadastradas no banco de dados.
            </p>
          </div>

          {error && (
            <div className="alert-error-estrutura">
              <span className="alert-icon">⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {success && (
            <div className="alert-success-estrutura">
              <span className="alert-icon">✅</span>
              <span>{success}</span>
            </div>
          )}

          <div className="modal-footer-estrutura">
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="btn-cancel-estrutura"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn-submit-estrutura"
            >
              {loading ? 'Gerando...' : 'Gerar Estrutura'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalGerarEstrutura;

